const Dashboard = ({ history }) => {
  
  return (
    "Dashboard"
  );
};

export default Dashboard;
